import { observer } from 'mobx-react-lite'
import { Divider, Scrollbar } from 'shared/ui'
import { useCompliancePageContext } from 'pages/settings/pages/compliance/context'
import { RegisterSection } from 'pages/settings/pages/compliance/ui/RegisterSection/RegisterSection'
import styles from './styles.module.scss'

export const CallingPage = observer(() => {
  const { callingPageStore } = useCompliancePageContext()

  return (
    <>
      <RegisterSection
        label={'Add-on'}
        type={'transparent'}
        titleType={'body-lg-medium'}
        {...callingPageStore.callingHeaderSectionProps}
      />
      <div className={styles.scrollbarWrap}>
        <Scrollbar
          className={styles.scrollbar}
          viewClassName={styles.scrollbar__view}
          autoHeight
          autoHeightMin={0}
          autoHeightMax={'100%'}
          height={'100%'}
        >
          <div className={styles.scrollbar__content}>
            {!callingPageStore.isGetAddOn && (
              <div className={styles.dividerWrap}>
                <Divider className={styles.divider} />
              </div>
            )}
            <RegisterSection
              {...callingPageStore.callingVoiceIntegrityRegisterSectionProps}
              containerClassName={callingPageStore.isGetAddOn ? '' : styles.containerWrap}
            />
            <RegisterSection {...callingPageStore.callingStirShakenRegisterSectionProps} />
            <RegisterSection {...callingPageStore.callingCnamCallerIdRegisterSectionProps} />
          </div>
        </Scrollbar>
      </div>
    </>
  )
})
